import type { FC } from 'react';
import { Link } from 'react-router-dom';

import { ROUTES } from '@/routes/route.config';

interface NavLinkItem {
  label: string;
  href: string;
}

interface SiteHeaderProps {
  links: NavLinkItem[];
  ctaLabel: string;
  ctaHref: string;
}

const SiteHeader: FC<SiteHeaderProps> = ({ links, ctaLabel, ctaHref }) => (
  <header className="sticky top-0 z-50 border-b border-[var(--color-divider)] bg-white/85 backdrop-blur">
    <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between gap-6 px-5 md:px-8">
      <Link to={ROUTES.home} className="flex items-center" aria-label="Shoutt home">
        <img src="/shoutt-wordmark.svg" alt="Shoutt" className="h-6 w-auto md:h-7" />
      </Link>

      <nav className="hidden items-center gap-8 md:flex" aria-label="Primary">
        {links.map((link) => (
          <a
            key={link.href}
            href={link.href}
            className="font-body text-sm font-medium text-[var(--color-ink-muted)] transition-colors hover:text-[var(--color-ink)]"
          >
            {link.label}
          </a>
        ))}
      </nav>

      {/* Hidden until the app is on the stores — the props and the #get-the-app
          section stay wired, so restoring it is uncommenting this block. */}
      {/* <a
        href={ctaHref}
        className="inline-flex h-10 items-center justify-center rounded-full bg-brand-500 px-5 font-body text-sm font-semibold text-white transition-colors hover:bg-brand-700"
      >
        {ctaLabel}
      </a> */}
    </div>
  </header>
);

export default SiteHeader;
